import React, { memo, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import axios from "axios";
import { Toast } from 'primereact/toast'
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { useFormik } from 'formik';
import { Api } from '../../../services/api';
import moment from "moment";
import './Leads.css'
import { InputText } from 'primereact/inputtext';
import { InputNumber } from "primereact/inputnumber";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Alert } from 'bootstrap';
import { set } from 'react-hook-form';


const LeadModel = ({ lead, onClose, onDataRefresh }) => {


  const toast = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [type, setType] = useState('Add');
  const [declinedTypeList, setDeclinedTypeList] = useState([]);
  const [siteVisitStageList, setSiteVisitStageList] = useState([]);
  const [ceStageList, setCeStageList] = useState([]);
  const [fsaStageList, setFsaStageList] = useState([]);
  const [contractStageList, setContractStageList] = useState([]);
  const [constructionStartStageList, setConstructionStartStageList] = useState([]);
  const [completionStageList, setCompletionStageList] = useState([]);
  const [projectTypeList, setProjectTypeList] = useState([]);
  const [leadSourceList, setLeadSourceList] = useState([]);
  const [leadsId, setLeadsId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add state for form submission

  const [leadStatus, setLeadStatus] = useState([]);


  //! ------------------------
  const [showConfirmation, setShowConfirmation] = useState(false); // State for showing confirmation dialog
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [showConfirmationDialogIsCall, setShowConfirmationDialogIsCall] = useState(false);
  const [formData, setFormData] = useState({});
  const [errorTitle, setErrorTitle] = useState('');
  const [dateChangeOrNot, setDateChangeOrNot] = useState(false);
  //! ------------------------



  const formik = useFormik({
    initialValues: {
      year: '',
      client: '',
      first_name: '',
      last_name: '',
      address: '',
      street_number: '',
      street_name: '',
      city: '',
      postal_code: '',
      email: '',
      cilentInformation: '',
      phone_number: '',
      lead_source: '',
      project_type: '',
      project_value: '',
      project_desc: '',
      contact_date: '',
      declined_type: '',
      site_visit_date: '',
      site_visit_stage: '',
      contact_to_site_visit_days: '',
      ce_sent_out: '',
      ce_stage: '',
      site_visit_to_ce_days: '',
      fsa_date: '',
      fsa_stage: '',
      ce_to_fsa_days: '',
      contract_date: '',
      contract_stage: '',
      fsa_to_contract_days: '',
      construction_start_date: '',
      construction_start_stage: '',
      construction_to_start_days: '',
      completion_date: '',
      completion_stage: '',
      completion_to_construction_days: '',
      notes: '',
      sr_pm_notes: '',
      vp_of_construction_comments: '',
      user_id: '',
      projectCreated: 'project create',


    },
    validate: (data) => {
      let errors = {};

      // if (!data.client) {
      //   errors.client = 'client is required.';
      // }

      if (!data.first_name) {
        errors.first_name = 'First Name is required.';
      }

      if (!data.last_name) {
        errors.last_name = 'Last Name is required.';
      }
      if (!data.street_number) {
        errors.street_number = 'Street Number is required.';
      }
      if (!data.street_name) {
        errors.street_name = 'Street Name is required.';
      }
      if (!data.project_value) {
        errors.project_value = 'Project Value is required.';
      }

      if (!data.lead_source) {
        errors.lead_source = 'lead source is required.';
      }
      if (!data.project_type) {
        errors.project_type = 'project type is required.';
      }
      if (!data.contact_date) {
        errors.contact_date = 'contact date is required.';
      }

      return errors;
    },

    onSubmit: (data) => {
      if (isSubmitting) return; // Prevent multiple submissions

      //! -------------------

      //! -------------------

      setIsSubmitting(true); // Set submitting state to true
      var url = Api.API_BASE_URL + 'leads-tracker/leads-create';

      if(dateChangeOrNot){
        if (data.fsa_date) {
          if (data.fsa_stage != 'FSA') {
            setIsSubmitting(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'FSA Stage is required.' });
            // setErrorTitle('FSA Stage is not selected . Do you want to submit it without an FSA Stage?');
            setErrorTitle('FSA Stage is not selected.');
            setShowErrorDialog(true);
  
            // <Dialog header="Error" visible={true} style={{ width: '50vw' }} dismissableMask="true" onHide={() => closeModel()}></Dialog>
            return;
          }
        }
  
        if (data.fsa_stage == 'FSA') {
          if (data.fsa_date=='Invalid date') {
            setIsSubmitting(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'FSA Date is required.' });
            setErrorTitle('FSA Date is not filled.');
            // setErrorTitle('FSA Date is not filled . Do you want to submit it without an FSA Date?');
            setShowErrorDialog(true);
            // <Dialog header="Error" visible={true} style={{ width: '50vw' }} dismissableMask="true" onHide={() => closeModel()}></Dialog>
            return;
          }
        }
  
        /**
        if (data.fsa_date && data.fsa_stage == 'FSA') {
          if (data.declined_type == 'TURNED DOWN' ||data.declined_type == 'LOST' || data.declined_type =='NOT PROCEEDING' || data.declined_type =='NOT PROCEEDING FSA') {
            setIsSubmitting(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Declined Type is required.' });
            setErrorTitle('This project is not created because the declined type is '+data.declined_type+'. Can you save the lead?');
            setShowErrorDialog(true);
            // <Dialog header="Error" visible={true} style={{ width: '50vw' }}   dismissableMask="true" onHide={() => closeModel()}></Dialog>
            return;
          }
        }
        */
      }
      if (data.fsa_date && data.fsa_stage == 'FSA' && showConfirmationDialogIsCall==false) {
        setShowConfirmationDialog(true);
        setIsSubmitting(false);
        return;
      }
    

      if (data.declined_type == 'TURNED DOWN' ||data.declined_type == 'LOST' || data.declined_type =='NOT PROCEEDING' || data.declined_type =='NOT PROCEEDING FSA') {
        data.projectCreated='project Not created'
   
      }

      console.log('data', data);


      if (type == "Edit") {
        url = Api.API_BASE_URL + 'leads-tracker/leads-update/' + leadsId;
      }
      let year = new Date(data.contact_date || new Date()).getFullYear();
      data.year = year;

      if (data.contact_date && data.site_visit_date) {
        data.contact_to_site_visit_days = DaysCalucate(data.contact_date, data.site_visit_date);
      } else {
        data.contact_to_site_visit_days = '';
      }

      if (data.site_visit_date && data.ce_sent_out) {
        data.site_visit_to_ce_days = DaysCalucate(data.site_visit_date, data.ce_sent_out);
      } else {
        data.site_visit_to_ce_days = '';
      }

      if (data.ce_sent_out && data.fsa_date) {
        data.ce_to_fsa_days = DaysCalucate(data.ce_sent_out, data.fsa_date);
      } else {
        data.ce_to_fsa_days = '';
      }

      if (data.fsa_date && data.contract_date) {
        data.fsa_to_contract_days = DaysCalucate(data.fsa_date, data.contract_date);
      } else {
        data.fsa_to_contract_days = '';
      }

      if (data.contract_date && data.construction_start_date) {
        data.construction_to_start_days = DaysCalucate(data.contract_date, data.construction_start_date);
      } else {
        data.construction_to_start_days = '';
      }

      if (data.construction_start_date && data.completion_date) {
        data.completion_to_construction_days = DaysCalucate(data.construction_start_date, data.completion_date);
      } else {
        data.completion_to_construction_days = '';
      }

      data.user_id = localStorage.getItem('user_id');
      data.client = data.first_name + " " + data.last_name;

     
            fetch(url, {
              method: "POST",
              headers: {
      
              },
              body: JSON.stringify(data),
            })
              .then((response) => response.json())
              .then((Josn) => {
                if (Josn.error != '') {
                  toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
      
                } else {
                  toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                  setIsModalOpen(false);
      
                  /// set time out after 5 second this line is running 
                  // setTimeout(() => {
                  //   onDataRefresh();
                  // }, 1500);
                  onDataRefresh();
      
      
                }
      
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setIsSubmitting(false); // Reset submitting state to false
              });
              
      

    }
  });

  const DaysCalucate = (first, second) => {
    let date = new Date(first);
    let currentDate = new Date(second);
    let days = Math.abs(Math.floor((currentDate.getTime() - date.getTime()) / 1000 / 60 / 60 / 24))
    return days.toString();
  }
  const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

  useEffect(() => {
    formik.resetForm();
    setIsModalOpen(true);
    getListData();
    setType('Add');
    if (lead.length != 0) {
      editCopyModal(lead, 'Edit');
    }

    return () => {
      // Cleanup tasks before the component is unmounted
    };
  }, [lead]);

  const getListData = async () => {

    axios.get(Api.API_BASE_URL + 'leads-tracker/leads-dropdown-list')
      .then((response) => {
        setDeclinedTypeList(response.data.declined_type);
        setProjectTypeList(response.data.project_type);
        setLeadSourceList(response.data.lead_source);
        setSiteVisitStageList(response.data.site_visit_stage);
        setCeStageList(response.data.ce_stage);
        setFsaStageList(response.data.fsa_stage);
        setContractStageList(response.data.contract_stage);
        setConstructionStartStageList(response.data.construction_start_stage);
        setCompletionStageList(response.data.completion_stage);

        // setIsLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching projects:', error);

      });

  }

  const editCopyModal = (rowData, colType) => {
    setLeadsId(rowData.id);
    formik.setFieldValue('client', rowData.client);
    formik.setFieldValue('first_name', rowData.first_name);
    formik.setFieldValue('last_name', rowData.last_name);
    formik.setFieldValue('address', rowData.address);
    formik.setFieldValue('street_number', rowData.street_number);
    formik.setFieldValue('street_name', rowData.street_name);
    formik.setFieldValue('city', rowData.city);
    formik.setFieldValue('postal_code', rowData.postal_code);
    formik.setFieldValue('email', rowData.email);
    formik.setFieldValue('cilentInformation', rowData.cilentInformation);
    formik.setFieldValue('phone_number', rowData.phone_number);
    formik.setFieldValue('project_type', rowData.project_type);
    formik.setFieldValue('contact_date', moment(rowData.contact_date).format('YYYY-MM-DD'));
    formik.setFieldValue('declined_type', rowData.declined_type);
    formik.setFieldValue('project_value', rowData.project_value);
    formik.setFieldValue('project_desc', rowData.project_desc);
    formik.setFieldValue('contact_to_site_visit_days', rowData.contact_to_site_visit_days);
    formik.setFieldValue('site_visit_to_ce_days', rowData.site_visit_to_ce_days);
    formik.setFieldValue('ce_sent_out', moment(rowData.ce_sent_out).format('YYYY-MM-DD'));
    formik.setFieldValue('site_visit_date', moment(rowData.site_visit_date).format('YYYY-MM-DD'));
    formik.setFieldValue('lead_source', rowData.lead_source);
    formik.setFieldValue('site_visit_stage', rowData.site_visit_stage);
    formik.setFieldValue('ce_stage', rowData.ce_stage);
    formik.setFieldValue('ce_to_fsa_days', rowData.ce_to_fsa_days);
    formik.setFieldValue('fsa_stage', rowData.fsa_stage);
    formik.setFieldValue('fsa_date', moment(rowData.fsa_date).format('YYYY-MM-DD'));
    formik.setFieldValue('contract_stage', rowData.contract_stage);
    formik.setFieldValue('contract_date', moment(rowData.contract_date).format('YYYY-MM-DD'));
    formik.setFieldValue('fsa_to_contract_days', rowData.fsa_to_contract_days);
    formik.setFieldValue('construction_start_stage', rowData.construction_start_stage);
    formik.setFieldValue('construction_start_date', moment(rowData.construction_start_date).format('YYYY-MM-DD'));
    formik.setFieldValue('construction_to_start_days', rowData.construction_to_start_days);
    formik.setFieldValue('completion_stage', rowData.completion_stage);
    formik.setFieldValue('completion_date', moment(rowData.completion_date).format('YYYY-MM-DD'));
    formik.setFieldValue('completion_to_construction_days', rowData.completion_to_construction_days);
    formik.setFieldValue('notes', rowData.notes);
    formik.setFieldValue('sr_pm_notes', rowData.sr_pm_notes);
    formik.setFieldValue('vp_of_construction_comments', rowData.vp_of_construction_comments);
    formik.setFieldValue('lead_status', rowData.status);

    console.log('rowData', typeof rowData.status);
    console.log('rowData', rowData);

    setType(colType);
    setIsModalOpen(true);

  };

  const renderDropdown = (label, fieldName, options, optionLabel) => (
    <div className="col-3 pt-3">
      <label style={{ fontSize: '14px' }}>{label}</label>
      <Dropdown
        optionValue='id'
        id={fieldName}
        name={fieldName}
        placeholder={`select ${label.toLowerCase()}`}
        options={options}
        optionLabel={optionLabel}
        value={formik.values[fieldName]}
        onChange={(e) =>{
          if(fieldName == 'fsa_stage')
            {setDateChangeOrNot(true);}
          formik.setFieldValue(fieldName, e.value)}}
        className={classNames('p-2', { 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%' }}
      />
    </div>
  );

  const renderInput = (label, fieldName, type = "text") => (
    <div className="col-3  pt-3">
      <label style={{ fontSize: '14px', }} >{label}</label>
      <InputText
        id={fieldName}
        name={fieldName}
        type={type}
        autoComplete="off"
        value={formik.values[fieldName]}
        onChange={(e) => formik.setFieldValue(fieldName, e.target.value)}
        className={classNames('p-2 ', { 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%' }}
      />
    </div>
  );



  const renderInputValue = (label, fieldName, type = "text") => (
    <div className="col-3  pt-3">
      <label style={{ fontSize: '14px', }} >{label} </label>
      <InputNumber
        inputId="currency-us"
        id={fieldName}
        name={fieldName}
        type={type}
        autoComplete="off"
        list="noSuggestions"
        value={formik.values[fieldName]}
        onChange={(e) => formik.setFieldValue(fieldName, e.value)}
        mode="currency"
        currency="USD"
        locale="en-US"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
        className={classNames({ 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%' }}
      />
    </div>
  );


  const renderDateInput = (label, fieldName) => (
    <div className="col-3 pt-3">
      <label style={{ fontSize: '14px' }}>{label}</label>
      <InputText
        id={fieldName}
        name={fieldName}
        type='date'
        autoComplete="off"
        value={formik.values[fieldName]}
        onChange={(e) => {
          if(fieldName == 'fsa_date')
          {setDateChangeOrNot(true);}
          formik.setFieldValue(fieldName, e.target.value)}}
        className={classNames('p-2', { 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%' }}
      />
    </div>
  );

  const renderTextarea = (label, fieldName) => (
    <div className="col-12 pt-3">
      <label style={{ fontSize: '14px' }}>{label}</label>
      <textarea
        id={fieldName}
        name={fieldName}
        autoComplete="off"
        value={formik.values[fieldName]}
        onChange={(e) => formik.setFieldValue(fieldName, e.target.value)}
        className={classNames('p-2')} style={{ width: '100%' }}
      />
    </div>
  );

  const closeModel = () => {
    setIsModalOpen(false);
    onClose();
  }

  const renderHtmlEditor = (label, fieldName) => (
    <div className="col-12 pt-3">
      <label style={{ fontSize: '14px' }}>{label}</label>
      {/* <div dangerouslySetInnerHTML={{ __html: formik.values[fieldName] }} /> */}
      <ReactQuill
        id={fieldName}
        name={fieldName}
        value={formik.values[fieldName]}
        onChange={(value) => formik.setFieldValue(fieldName, value)}
        className="p-2"
      />
    </div>
  );

  const footerContent = (
    <div className='m-2' >
        <Button label="Cancel" title='Cancel' severity="secondary" className='p-1 m-1' onClick={() => setShowErrorDialog(false)}/>
        {/* <Button label="No" icon="pi pi-times" severity="danger" className='p-1 m-1'  onClick={() => setShowErrorDialog(false)} /> */}
        {/* <Button label="Yes" onClick={()=>{
            setShowErrorDialog(false);
            setDateChangeOrNot(false);
         
        }} severity="success" autoFocus className='p-1 m-1' /> */}
    </div>
);

const footerContentConfirmation = (
  <div className='m-2 ' >
     <Button label="Cancel" title='Cancel'  severity="secondary" className='p-1 m-1'  onClick={() =>  setShowConfirmationDialog(false)} />
      <Button label="No" title='No' severity="danger" className='p-1 px-4 m-1 mx-2'onClick={()=>{
          setShowConfirmationDialog(false);
          setShowConfirmationDialogIsCall(true);
          // setDateChangeOrNot(false);
          setErrorTitle('');
        formik.setFieldValue('projectCreated', 'project not create');
        formik.handleSubmit();
      }} />
     
      <Button label="Yes" title='Yes' onClick={()=>{
          setShowConfirmationDialog(false);
          setShowConfirmationDialogIsCall(true);
          // setDateChangeOrNot(false);
          setErrorTitle('');
        formik.setFieldValue('projectCreated', 'project create');
        formik.handleSubmit();
      }} severity="success" autoFocus className='p-1 px-4 m-1 mx-2' />
  </div>
);


  return (
    <>
      <Toast ref={toast} />
      <Dialog header="Error" headerClassName="error-header" visible={showErrorDialog} style={{ width: '30vw' }} dismissableMask={true} onHide={() => setShowErrorDialog(false)} footer={footerContent}>
        {/* Dialog content */}
       
        <div className=" m-2 item-center justify-center">
          <span style={{ marginBottom: '1rem' }}>{errorTitle}</span>
         
          {/* <Button label="OK" onClick={() => setShowErrorDialog(false)} /> */}
        </div>
      </Dialog>

      <Dialog header="Confirmation" headerClassName="centered-header" visible={showConfirmationDialog} style={{ width: '30vw' }} dismissableMask={true} onHide={() => setShowConfirmationDialog(false)} footer={footerContentConfirmation}>
        {/* Dialog content */}
       
        <div className=" m-2 item-center justify-center">
          <span style={{ marginBottom: '1rem' }}>It will create a project in production schedule and playbook. Do you want to continue ?</span>
         
        
        </div>
      </Dialog>

      {/* // --------------------------------dialog Box------------------------------------------------------ */}
      <Dialog header={`${type} Lead`} visible={isModalOpen} maximizable style={{ width: '75vw' }} className="dashboard-dialog" dismissableMask="true" onHide={() => closeModel()}>

        <div className='card'>
          <form onSubmit={formik.handleSubmit} className="">
            <div className="formgrid grid m-2">
              {/* {renderInput("Client", "client", "text")} */}
              {/* {renderInput("Address", "address")} */}
              {renderInput("First Name", "first_name")}
              {renderInput("Last Name", "last_name")}
              {renderInput("Street Number", "street_number")}
              {renderInput("Street Name", "street_name")}
              {renderInput("City", "city")}
              {renderInput("Postal Code", "postal_code")}
              {renderInput("Email", "email", "text")}
              {renderInput("Phone Number", "phone_number", "text")}
              {renderDropdown("Lead Source*", "lead_source", leadSourceList, "name")}
              {renderDropdown("Project Type*", "project_type", projectTypeList, "name")}
              {renderInputValue("Project Value", "project_value")}
              {renderDateInput("Contact Date*", "contact_date")}
              {renderDropdown("Declined Type", "declined_type", declinedTypeList, "name")}
              {renderDateInput("Site Visit Date", "site_visit_date")}
              {renderDropdown("Site Visit Stage", "site_visit_stage", siteVisitStageList, "name")}
              {renderDateInput("CE Sent out", "ce_sent_out")}
              {renderDropdown("CE Stage", "ce_stage", ceStageList, "name")}
              {renderDateInput("FSA Date", "fsa_date")}
              {renderDropdown("FSA Stage", "fsa_stage", fsaStageList, "name")}
              {renderDateInput("Contract Date", "contract_date")}
              {renderDropdown("Contract Stage", "contract_stage", contractStageList, "name")}
              {renderDateInput("Construction Start Date", "construction_start_date")}
              {renderDropdown("Construction Start Stage", "construction_start_stage", constructionStartStageList, "name")}
              {renderDateInput("Completion Date", "completion_date")}
              {renderDropdown("Completion Stage", "completion_stage", completionStageList, "name")}
              {renderDropdown("Status", "lead_status", [{ id: '1', name: "ACTIVE" }, { id: '2', name: "HOLD" }, { id: '0', name: "DELETED" },], "name")}

              {renderHtmlEditor("Project Description", "project_desc")}
              {renderHtmlEditor("Client Information", "cilentInformation")}
              {renderHtmlEditor("Note 1 - Sales", "notes")}
              {/* {renderHtmlEditor("Note 2 - Pre-construction manager", "sr_pm_notes")} */}
              {/* {renderHtmlEditor("Note 3 - VP Sales & Marketing", "vp_of_construction_comments")} */}
              {renderHtmlEditor("Note 3 - Supervisor", "vp_of_construction_comments")}

            </div>
            <div className="card flex flex-wrap justify-content-center gap-3 pt-3">
              <Button label="Submit" type="submit" title='Save the Leads' icon="pi pi-check" className='p-2 customSave-button' loading={isSubmitting} disabled={isSubmitting} />
            </div>
          </form>


        </div>
      </Dialog>



    </>

  )
}

export default LeadModel